async function getUserLoans(user, setUserLoans) {
  const targetUrl = `${process.env.CMS_URL}/loans`;

  const token = await user.getIdToken();

  const res = await fetch(targetUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const respJSON = await res.json();

  if (respJSON) {
    // filter out status:deleted loans from users view

    const filtered = respJSON.filter((userLoan) => {
      return (
        userLoan.Status !== "deleted" &&
        Object.keys(userLoan.SelectedLoan).length > 0
      );
    });

    if (setUserLoans) {
      setUserLoans(filtered);
    }

    return filtered;
  }
}

export default getUserLoans;
